import React from 'react';
import PropTypes from 'prop-types';

import { Logger } from 'aws-amplify';

import {
    Snackbar,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
    Alert as MuiAlert,
} from '@material-ui/lab';

const logger = new Logger('Message');

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function SnackbarAlert(props) {

  const { message, severity, duration, open, onClose, anchorOrigin } = props; 

  const classes = useStyles();
 
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    if(onClose) {
      onClose();
    }
  };
  
  logger.debug("MESSAGE: ", message);

  if(!message) {
    return(null);
  }

  return (
    <div className={classes.root}>
      <Snackbar 
        open={open} 
        onClose={handleClose}
        autoHideDuration={duration} 
        anchorOrigin={anchorOrigin}
      >
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}

SnackbarAlert.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  duration: PropTypes.number,
  anchorOrigin: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

SnackbarAlert.defaultProps = {
  open: false,
  variant: 'error',
  duration: 6000,
  anchorOrigin: { vertical: "bottom", horizontal: "center" }
};
